import React from 'react';
import PropTypes from 'prop-types';
import { classes } from './Start.st.css.js';
class Start extends React.PureComponent {
    static { this.propTypes = {
        children: PropTypes.node,
    }; }
    render() {
        const { children } = this.props;
        return React.createElement("div", { className: classes.start }, children);
    }
}
export default Start;
//# sourceMappingURL=Start.js.map